module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/barclays_social_media_spot.jpg";